module.exports = __webpack_public_path__ + "static/media/background-sucess-analise.4d7b96cd.svg";